import { Provider } from '@angular/core';

import { runOnFeatureInit } from '@frontend/vanilla/core';

import { StoryContentWidgetRegistration } from './widget-registration.service';

export function provide(): Provider[] {
    return [runOnFeatureInit(StoryContentWidgetRegistration)];
}
